/*
 * Programación (drip) de una sección (LMS-108/109): días desde la matrícula o
 * fecha fija, nunca las dos. Espejo de `ValidatesDripSchedule` del backend.
 */
export const DRIP_MIN_DAYS = 1
export const DRIP_MAX_DAYS = 3650

export const DRIP_MODES = {
    immediate: 'immediate',
    days: 'days',
    date: 'date',
}

// `available_from` llega como ISO; la fecha se trata como día natural (sin hora).
const dateOnly = (iso) => (iso ? String(iso).slice(0, 10) : '')

export const scheduleOf = (section) => {
    if (section?.drip_days_after_enrolment) {
        return {mode: DRIP_MODES.days, days: section.drip_days_after_enrolment, date: ''}
    }
    if (section?.available_from) {
        return {mode: DRIP_MODES.date, days: null, date: dateOnly(section.available_from)}
    }
    return {mode: DRIP_MODES.immediate, days: null, date: ''}
}

export const hasDrip = (section) => scheduleOf(section).mode !== DRIP_MODES.immediate

// Texto corto para el distintivo de la cabecera, o '' si no hay programación.
export const dripLabel = (section, t, locale) => {
    const schedule = scheduleOf(section)
    if (schedule.mode === DRIP_MODES.days) {
        return t('projects.drip_badge_days', {count: schedule.days}, schedule.days)
    }
    if (schedule.mode === DRIP_MODES.date) {
        const date = new Date(schedule.date + 'T00:00:00Z')
        const formatted = date.toLocaleDateString(locale, {day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC'})
        return t('projects.drip_badge_date', {date: formatted})
    }
    return ''
}
